
import { defineComponent } from "vue";
import { Form, Field } from "vee-validate";
//import Swal from "sweetalert2/dist/sweetalert2.min.js";
// import * as Yup from "yup";
import ApiService from "@/core/services/ApiService";

export default defineComponent({
  name: "new-entity-course",
  components: {
    Form,
    Field,
  },
  data() {
    return {
      batch: {},
      employee: {},
      details: {},
      weekplan: {},
      entityTypes: [],
      industry: [],
      entityInfos: [],
      divisions: [],
      districts: [],
      subDistricts: [],
      empDistricts: [],
      traineeSelected: [],
      trainee_ids: [],
      select_trainee_ids: [],
      traineeInfo: [
        {
          id: 1,
          name: "Zohirul Alam Tiemoon",
        },
        {
          id: 2,
          name: "Md. Nahidur Rahman Rifath",
        },
        {
          id: 3,
          name: "Md Abdul Alim",
        },
      ],
      loading: false,
      traineeInfoData: false,
      showCourseNotice: false,
      showTraineeList: false,
      showMapTraineeList: false,
      showtrainingProviderNotice: false,
    };
  },
  async created() {
    await this.getEntityTypes();
    await this.getEntityInfos();
  },
  methods: {
    async formSubmit() {
      //form submit
    },
    async getEntityInfos() {
      await ApiService.get("entity/infos")
        .then((response) => {
          this.entityInfos = response.data;
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    async getEntityTypes() {
      await ApiService.get("entity/types")
        .then((response) => {
          this.entityTypes = response.data;
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },

    selectedTrainee() {
      this.trainee_ids.map((item) => {
        var check = 0;
        this.traineeSelected.map((s_item) => {
          if (s_item['id'] == item['id']) {
            check = 1;
          }
         });

         for( var i = 0; i < this.traineeInfo.length; i++){ 
            if (this.traineeInfo[i]['id'] === item['id']) { 
                this.traineeInfo.splice(i, 1); 
            }
        }
         if(check == 0){
          this.traineeSelected.push(item);
         }
      });
    },
    unselectedTrainee() {
      this.select_trainee_ids.map((item) => {
        var check = 0;
        this.traineeInfo.map((s_item) => {
          if (s_item['id'] == item['id']) {
            check = 1;
          }
         });

         for( var i = 0; i < this.traineeSelected.length; i++){ 
            if (this.traineeSelected[i]['id'] === item['id']) { 
                this.traineeSelected.splice(i, 1); 
            }
        }
         if(check == 0){
          this.traineeInfo.push(item);
         }
      });
    },
    selectedAllTrainee() {
      Array.prototype.push.apply(this.traineeSelected,  this.traineeInfo);
      this.traineeInfo.splice(0);
    },
    unselectedAllTrainee() {
      Array.prototype.push.apply(this.traineeInfo,  this.traineeSelected);
      this.traineeSelected.splice(0);
    },
    traineeInfo() {
      this.traineeInfoData = true;
    },
    traineeList() {
      this.showTraineeList = true;
    },
    traineeMapList() {
      this.showMapTraineeList = true;
    },
    trainingProviderNotice() {
      this.showtrainingProviderNotice = true;
    },
  },
  setup() {
    const AssociationSchema = [];
    return {
      AssociationSchema,
    };
  },
});
